var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5C11.5 9.26 9.26 11.5 6.5 11.5C3.74 11.5 2.055 8.72 2.055 8.72M2.055 8.72H4.315M2.055 8.72V11.22M1.5 6.5C1.5 3.74 3.72 1.5 6.5 1.5C9.835 1.5 11.5 4.28 11.5 4.28M11.5 4.28V1.78M11.5 4.28H9.28",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOne);
export default __webpack_public_path__ + "static/media/refresh-one.c973219ad91a3970505f767c43c26684.svg";
export { ForwardRef as ReactComponent };